import Vue from 'vue'

var bus = new Vue();
export default bus;



// WEBPACK FOOTER //
// ./src/libs/event-bus.js